import { Repository } from 'app/services/database/repository';
import { DeviceModel } from 'app/views/devices/models/device.model';

export class DeviceRepository extends Repository<DeviceModel> {
    protected get path() { return '/devices/'; }
}



// WEBPACK FOOTER //
// ./src/app/services/database/device.repository.ts